import cn from 'classnames';

const Container = ({
  fluid, children, className, ...attrs
}) => {
  const combinedClassName = cn(className, {
    'container-fluid': !!fluid,
    container: !fluid,
  });
  return (
    <div className={combinedClassName} {...attrs}>
      { children }
    </div>
  );
};

export default Container;
